import * as _ from 'lodash'

import { PagingDto } from "./paging.dto"
import { TranslationDto } from "./translation.dto"
import { BaseDto } from './base.dto'
import { GalleryDto } from './gallery.dto'
import { PromotionDto } from './promotion.dto'
import { MallDto } from './mall.dto'

export class FindPushNotificationDto extends PagingDto {
  
}

export class CreatePushNotificationDto {
  title?: TranslationDto
  message?: TranslationDto
  creator?: string
  link?: string

  static create({ title, message, creator, link }: CreatePushNotificationDto) {
    return _.assign(new PushNotificationDto(), {
      title: title || TranslationDto.create(),
      message: message || TranslationDto.create(),
      creator,
      link
    })
  }
}

export class PushNotificationDto {
  title: TranslationDto
  message: TranslationDto
  link: string

  static create({ title, message }: PushNotificationDto) {
    return _.assign(new PushNotificationDto(), {
      title: title || TranslationDto.create(),
      message: message || TranslationDto.create()
    })
  }
}

export class NotificationLogDto extends BaseDto {
  dataId: string
  action: string
  status: string
  data: any
  completedAt: Date
  nextExecuteAt: Date
  gallery: GalleryDto
  promotion: PromotionDto
  mall: MallDto
  pushNotification: PushNotificationDto
}